module.exports = __webpack_public_path__ + "img/nammaflix_logo.f3e715e2.png";